import env, { projectName } from "../utils/generator";

export default (): void => env.run(projectName);
